import loadable from '@loadable/component'

export default [
  {
    // 房间party礼包
    path: '/RoomPartyGift',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-RoomPartyGift" */ '~/pages/RoomPartyGift'
        )
    ),
  },
  {
    // 房间party礼包 排行榜
    path: '/RoomPartyRank',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-RoomPartyRank" */ '~/pages/RoomPartyGift/RoomPartyRank'
        )
    ),
  },
]
